module.exports = {
  ajaxPrefix: '//m.meitun.com',
  otherAjaxPrefix: '//msit.meitun.com',
  babytreeAjaxPrefix: '//9.babytree-test.com',
  babytreeLoginPrefix: '//m.9.babytree-test.com',
  IMappKey: '0c30bfdb0776ebf6d554dfb27b44a478',
  IMAjaxPrefix: '//mapiweb.babytree-test.com',
  IMDebug: true,
  localMsglimit: 36
};



// WEBPACK FOOTER //
// ./src/config/dev.config.js